module.exports = __webpack_public_path__ + "img/bg_2024.e522aed.png";